
import { map } from 'rxjs/operators';
import { Component } from '@angular/core';
import { KeyValue } from '../key-value';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationService } from '../authorization.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'report-viewer',
  templateUrl: 'report-viewer.component.html',
  styleUrls: ['./report-viewer.component.css'],
})
export class ReportViewerComponent {
  sub: any;
  comm: any;
  report: any;
  team: any;
  qtr: any;
  report_data = '';
  report_type = '';
  svg_graph1 = '';
  svg_graph2 = '';
  svg_graph3 = '';
  svg_graph4 = '';
  date1 = '';
  date2 = '';
  community = '';
  banks = [];
  ins_reports = [];
  com_reports = [];
  communities = [];
  teams = [];
  index: any;
  t_index: any;
  q_index: any;
  start: any;
  instr: any;
  file_type = [];
  c_reports = [];
  r_val: any;
  b_r = [];
  stud: any;
  what_if = '';
  i_teams = [];
  token: any;
  foooter = '';
  bin_file = false;
  is_print = 'false';
  is_init: string = '';
  ind_report = false;
  qtrs = [];
  b_reports = [];
  role = '';
  current_category = '';

  constructor(
    private router: Router,
    private KeyValueService: KeyValue,
    private route: ActivatedRoute,
    public authService: AuthorizationService
  ) {
    this.sub = this.route.queryParams.subscribe((params) => {
      this.comm = params['c'] || '';
      this.report = params['r'] || '';
      this.team = params['t'] || '';
      this.qtr = params['q'] || '';
      this.start = params['start'] || '';
      this.instr = params['instr'] || '';
      this.q_index = params['q_index'] || '';
      this.stud = params['s'] || '';
      this.what_if = params['what_if'] || '';
      this.token = params['token'] || 'undefined';
      this.bin_file = false;
      this.is_print = params['print'] || undefined;
      this.is_init = params['init'] || undefined;
      this.ind_report = params['ind_report'] || false;
      console.log(this.stud);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.is_print) {
        console.log('printtt .....');
        window.print();
      }
    }, 1500);
  }

  checkIfInit() {
    if (this.is_init != undefined) {
      // r=B01-Balance%20Sheets&start=undefined
      const rData = JSON.parse(localStorage.getItem('r_data') || '{}');
      this.report =
        this.banks && this.banks.length > 0
          ? this.banks[0]
          : rData.report_nav.b_reports[0];
      this.stud = 'student';
    }
  }

  ngOnInit() {
    this.role = this.authService.getCRole();
    this.current_category = this.authService.current_category();

    if (
      navigator.userAgent.indexOf('Edge') > -1 ||
      navigator.userAgent.indexOf('Trident/7.0') > -1
    ) {
      if (
        this.token !== localStorage.getItem('accessToken') &&
        this.token !== 'undefined'
      ) {
        localStorage.setItem('accessToken', this.token);
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }
    }

    if (this.role == 'Student') {
      const data = JSON.parse(localStorage.getItem('r_data'));
      console.log('data11 ...', data);
      if (data != null && data != undefined) {
        this.qtrs = data.report_nav.qtrs;
        this.b_reports = data.report_nav.b_reports;
        this.team = data.report_nav.teams[0];
        this.comm = data.report_nav.communities[0];
        if (data.report_nav.reports.length > 0) {
          this.banks = data.report_nav.reports[0].bank;
        }
      }
      this.q_index = 0;
      if (!this.qtr && this.qtrs && this.qtrs.length > 0) {
        this.qtr = this.qtrs[this.qtrs.length - 1];
      } else if (this.qtr == 'start' || !this.qtr) {
        this.start = 'undefined';
      }
      console.log('ddddddddddddd');
      console.log(this.qtrs);
    }

    console.log(
      this.comm + ' ' + this.team + ' ' + this.report + ' ' + this.qtr
    );
    if (this.role == 'Student') this.checkIfInit();

    this.authService
      .get('/v1/reports/sim_report' + this.reportUrlString())
      .pipe(map((res) => res))
      .subscribe(
        (data) => {
          this.foooter = data.footer;
          this.report_data = data.report;
          this.report_type = data.type;
          this.svg_graph1 = data.svg_graph1;
          this.svg_graph2 = data.svg_graph2;
          this.svg_graph3 = data.svg_graph3;
          this.svg_graph4 = data.svg_graph4;
          this.date1 = data.date1;
          this.date2 = data.date2;
          this.community = data.community;
          // --- Extract h1/p for B00 Table of Contents ---
          if (
            this.report &&
            this.report.endsWith('B00-Table of Contents') &&
            this.report_data
          ) {
            try {
              const parser = new DOMParser();
              const doc = parser.parseFromString(
                this.report_data,
                'text/html'
              );
              const h1 = doc.querySelector('h1.pdf-left.pdf-report-title');
              const p = doc.querySelector('p.pdf-right.pdf-report-title');
              if (h1) this.date1 = h1.textContent.trim();
              if (p) this.date2 = p.textContent.trim();
            } catch (e) {
              // fallback: do nothing
            }
          }
          // --- End extract ---

          this.file_type = [
            'pdf',
            'decision',
            'community',
            'excel',
            'instructor',
            'decisions',
            'breports',
            'breports_enhanced',
            'instructor_' + this.comm,
          ];
          if (
            this.file_type.includes(this.report) ||
            String(this.ind_report) == 'true'
          ) {
            this.bin_file = true;
            window.location.href =
              environment.base_url +
              '/v1/reports/binary_report?type=' +
              this.report_type +
              '&fkey=' +
              this.report_data;
            // setTimeout(()=>{window.close()},100)
          }
          if (this.what_if == 'true' && data.whatif_reports) {
            this.constructString(data);
          } else {
            // need to check why localstorage r_data is not setting
            this.constructString(
              JSON.parse(localStorage.getItem('/v1/home/set_current_session'))
            );
          }
          this.renderData(this.report_data);
        },
        (error) => {
          console.log('in... signin success' + error);
        }
      );
  }

  renderData(data) {
    setTimeout(() => {
      if ((data !== undefined && data.includes('div')) || this.svg_graph1) {
        document.getElementById('pre_content').innerHTML = '';
        document.getElementById('pre_content').style.display = 'none';
        document.getElementById('report_content_1').innerHTML = data;
      } else {
        document.getElementById('pre_content').innerHTML = data;
        document.getElementById('report_content_1').innerHTML = '';
        document.getElementById('pre_content').style.display = 'inline-block';
      }
    }, 300);
  }

  constructString(data) {
    console.log('consString  ');
    console.log(data);
    //    this.teams = data.report_nav.teams[0]
    if (this.what_if == 'true') {
      console.log('bank1');
      this.banks = data.whatif_reports.split(',');
    } else {
      this.teams = [].concat(...data.report_nav.teams);
      this.i_teams = data.report_nav.teams;
      console.log('this.what_if ..' + this.what_if + (this.what_if == ''));
      if (this.start === 'undefined') {
        console.log('bank2');
        this.banks = data.report_nav.b_reports;
        this.index = this.banks.indexOf(this.report);
      } else if (this.instr === '') {
        console.log('bank3');
        this.banks = data.report_nav.reports[this.q_index].bank;
      } else {
        console.log('bank4');
        this.ins_reports = data.report_nav.reports[this.q_index].ins;
        this.communities = data.report_nav.communities;
        this.set_report();
      }
    }
    this.t_index = this.teams.indexOf(this.team);
    this.index = this.banks.indexOf(this.report);
    if (this.index === -1 && this.communities.length > 0) {
      const commIdx = this.communities.indexOf(this.comm);
      if (commIdx !== -1 && this.i_teams[commIdx]) {
        const teamIdx = this.i_teams[commIdx].indexOf(this.team);
        if (teamIdx !== -1) {
          const withTeamSuffix = this.report + '-' + (teamIdx + 1);
          const altIndex = this.banks.indexOf(withTeamSuffix);
          if (altIndex !== -1) {
            this.index = altIndex;
            this.report = this.banks[this.index];
          }
        }
      }
    }
  }

  set_report() {
    this.com_reports = [
      'C91-Bank Balance Sheets',
      'C92-Income Statements',
      'C93-Community Loan and Deposit Markets',
      'C94-Community Bank Capital Activity',
      'C94A-Capital Ratio Requirements',
      'C95-Economic Charts',
      'C96-Economic Reporter',
      'I98-Risk and Stock Price Analysis',
    ];
    for (let c = 0; c < this.communities.length; c++) {
      this.c_reports = [];
      for (const ins of this.ins_reports) {
        for (let i = 0; i < this.i_teams[c].length; i++) {
          if (!this.com_reports.includes(ins)) {
            this.banks.push(
              this.communities[c] + '-' + ins + '-' + (i + 1)
            );
          } else if (i === 0 && this.com_reports.includes(ins)) {
            this.c_reports.push(this.communities[c] + '-' + ins);
          }
        }
      }
      this.banks.push(...this.c_reports);
    }
  }

  selectQtr(val1) {
    console.log('selectQtr ...');
    console.log(val1);
    console.log(this.reportUrlString());
    this.qtr = val1;
    this.start = '';
    if (val1 === 'start') this.start = 'undefined';
    this.q_index = 0;
    window.location.href =
      window.location.origin + '/report/viewer' + this.reportUrlString();
  }

  navBarChange(val, key) {
    if (this.instr !== 'undefined') {
      if (key.split('_')[0] === 'report') {
        this.report = val;
      } else {
        this.comm = val.split(' ')[1][0];
        this.team = val;
      }
    } else {
      this.instrReportSetUp(val);
    }
    window.location.href =
      window.location.origin + '/report/viewer' + this.reportUrlString();
  }

  instrReportSetUp(val) {
    this.r_val = val.split('-');
    this.report = val;
    this.comm = this.r_val[0];
    this.team =
      'Team' +
      ' ' +
      this.r_val[0] +
      (this.r_val[3] || this.i_teams[this.communities.indexOf(this.comm)].length);
  }

  navBarNext(key) {
    if (this.instr !== 'undefined') {
      if (key.split('_')[0] === 'report') {
        this.index = this.banks.indexOf(this.report) + 1;
        this.report = this.banks[this.index];
      } else {
        this.t_index = this.teams.indexOf(this.team) + 1;
        this.team = this.teams[this.t_index];
        this.comm = this.team.split(' ')[1][0];
      }
    } else {
      this.instrReportSetUp(
        this.banks[this.banks.indexOf(this.report) + 1]
      );
    }
    window.location.href =
      window.location.origin + '/report/viewer' + this.reportUrlString();
  }

  navBarPrev(key) {
    if (this.instr !== 'undefined') {
      if (key.split('_')[0] === 'report') {
        this.index = this.banks.indexOf(this.report) - 1;
        this.report = this.banks[this.index];
      } else {
        this.t_index = this.teams.indexOf(this.team) - 1;
        this.team = this.teams[this.t_index];
        this.comm = this.team.split(' ')[1][0];
      }
    } else {
      this.instrReportSetUp(
        this.banks[this.banks.indexOf(this.report) - 1]
      );
    }
    window.location.href =
      window.location.origin + '/report/viewer' + this.reportUrlString();
  }

  navBarClose() {
    // windw.close()
    this.router.navigate([KeyValue.studentHomePath]);
  }

  openPDFReportForStudent() {
    let url = '';
    if (this.start == 'undefined') {
      url = `/report/viewer?r=pdf&start=undefined&token=${this.token}`;
    } else {
      url = `/report/viewer?c=${this.comm}&t=${this.team}&r=pdf&q=${this.qtr}&q_index=1&ind_report=${true}&token=${this.token}`;
    }
    window.open(url, '_blank').focus();
  }

  openExcelReportForStudent() {
    let url = '';
    if (this.start == 'undefined') {
      url = '';
    } else {
      url = `/report/viewer?c=${this.comm}&t=${this.team}&r=excel&q=${this.qtr}&q_index=${this.q_index}&token=${this.token}`;
    }
    window.open(url, '_blank').focus();
  }

  reportUrlString(): string {
    return (
      '?c=' +
      this.comm +
      '&t=' +
      this.team +
      '&r=' +
      this.report +
      '&q=' +
      this.qtr +
      '&start=' +
      this.start +
      '&instr=' +
      this.instr +
      '&q_index=' +
      this.q_index +
      '&s=' +
      this.stud +
      '&what_if=' +
      this.what_if +
      '&ind_report=' +
      this.ind_report +
      '&token=' +
      this.token
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  formatBankName(bank: string): string {
    return bank ? bank.split('-').join(': ') : '';
  }

  closeTab(): void {
    window.close();
  }
}
